import { SharedSubFlowV2BlockFormFields } from '../../SubFlow/v2/SharedFormFields';
import { FlowKind } from '../../constants';

export function SkillV2BlockFormFields() {
  return (
    <SharedSubFlowV2BlockFormFields
      fieldNamePrefix="config"
      variant="SkillV2"
      allowedFlowKinds={[FlowKind.Skill]}
    />
  );
}
